@if (campaignDetails(); as campaign) {
  <div class="action-card-preview-container" *transloco="let t">

    @if (background(); as background) {
      @if (backgroundIsBlob()) {
        <!--suppress AngularNgOptimizedImage -->
        <img [src]="background" class="action-card-image" [class.expanded]="expanded()" alt="Sponsor Image" width="367"
             height="254" priority="true"/>
      } @else {
        <img [ngSrc]="background" class="action-card-image" [class.expanded]="expanded()" alt="Sponsor Image"
             width="367" height="254" priority="true"/>
      }

    } @else {
      <div class="action-card-image-fallback" [class.expanded]="expanded()"></div>
    }

    <div class="action-card-shortcut-information-container">
      <div class="action-card-shortcut-information" [class.redeemed]="campaignUserStatus() == CampaignUserStatus.REDEEMED" >
        @if (campaignUserStatus() == CampaignUserStatus.REDEEMED) {
          <div class="chip redeemed">
            <mat-icon svgIcon="circle-check"></mat-icon>
            {{ t('mobile.redeemedCampaignsStats.redeemed') }}
          </div>
        }
        <div class="chip">{{ campaignDetails().reward | loyaltyCurrency }}</div>
      </div>
    </div>

    <mat-expansion-panel class="action-card-expansion-panel" [disabled]="isStatic()"
                         [expanded]="expanded() || isStatic()" (opened)="onPanelOpen()"
                         (closed)="onPanelClose()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <lib-campaign-card-sponsor-header class="w-100" [campaignDetails]="campaign"
                                            (valueRatingOpened)="this.valueRatingOpened.emit()">
          </lib-campaign-card-sponsor-header>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="promotion-container" [class.redeemed]="campaignUserStatus() == CampaignUserStatus.REDEEMED">
        @if (campaign.type == CampaignType.FREE_MONEY) {
          <lib-campaign-card-sentence-sponsor class="sentence"
                                              [campaign]="campaign"></lib-campaign-card-sentence-sponsor>
        } @else {
          <lib-campaign-card-sentence-merchant class="sentence merchant" [campaign]="campaign"
                                               [highContrast]="true"></lib-campaign-card-sentence-merchant>
        }

        <app-campaign-card-promo-details [campaign]="campaignDetails()"
                                         [campaignUserStatus]="campaignUserStatus()"
                                         [displayLocation]="false"
                                         class="campaign-card-promo-details"
        ></app-campaign-card-promo-details>
<!--        @if (campaign.type == CampaignType.FREE_MONEY) {-->
          <div class="free-money-buttons-container">
            @if (isStatic() || !isDemoMode()) {
              <button mat-stroked-button class="button-medium"
                      (click)="openLocationsSlideIn()">
                {{ t('actions.card.newActionPreviewDetails.buttons.viewLocations') }}
              </button>
            }
            @if ((isStatic() || !isDemoMode()) && campaign.id && campaignUserStatus() != CampaignUserStatus.REDEEMED) {
              <button mat-stroked-button class="button-medium button-outlined"
                      (click)="openHowToRedeemSlideIn()">
                {{ t('actions.card.newActionPreviewDetails.buttons.howToRedeem') }}
              </button>
            }
          </div>
<!--        }-->
      </div>
<!--      @if (campaign.type == CampaignType.LOYALTY && (!isDemoMode() || isStatic())) {-->
<!--        <div class="loyalty-buttons-container">-->
<!--          <div (click)="howToRedeemOpened.emit()">-->
<!--            {{ t('actions.card.newActionPreviewDetails.buttons.getDirections') }}-->
<!--          </div>-->
<!--          <div class="loyalty" (click)="withStaticCheck(loyaltyInfoOpened.emit)">-->
<!--            <lib-loyalty-radial-bar [loyaltyScore]="campaign.userLoyalty.loyaltyScore"-->
<!--                                    [loyaltyLevel]="campaign.userLoyalty.level"-->
<!--                                    [size]="Size.BIG"></lib-loyalty-radial-bar>-->
<!--            <div>{{ t('loyaltyLevels.' + campaign.userLoyalty.level) + ' ' + campaign.userLoyalty.loyaltyScore }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      }-->

    </mat-expansion-panel>

  </div>
}

